var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TitleCard',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('Title',[_vm._v(_vm._s(_vm.titleName))])]},proxy:true},{key:"com",fn:function(){return [_c('ButtonSelection',{attrs:{"BGColor":true,"buttonList":_vm.btnList},on:{"setButtonSelectFn":_vm.setButtonSelectFn}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }